module.exports = __webpack_public_path__ + "img/alagreen-logo.949c8281.jpg";